import React, { createContext, useState, useCallback, ReactNode } from 'react';
import { Toast } from '../types';

interface ToastContextType {
  showToast: (toast: Omit<Toast, 'id'>) => void;
  toasts: Toast[];
}

export const ToastContext = createContext<ToastContextType | undefined>(
  undefined
);

interface ToastProviderProps {
  children: ReactNode;
}

export const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const showToast = useCallback((toast: Omit<Toast, 'id'>) => {
    const id = `toast-${Date.now()}-${Math.random()}`;
    const duration = toast.duration || 3000;
    const newToast: Toast = { ...toast, id, duration };

    setToasts((prev) => {
      const updated = [...prev, newToast];
      // Limit to 3 toasts max
      return updated.slice(-3);
    });

    // Auto-dismiss after duration
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, toasts }}>
      {children}
    </ToastContext.Provider>
  );
};
